
<span>
  Property: <strong>{{model.linkedRelationPropertyLabelTitle}}</strong> &nbsp;
</span>
